export default __webpack_public_path__ + "static/media/event_image_placeholder.fe81fe62.jpg";